import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function GPUDedicatedServerFrance() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "GPU Dedicated Server France | Powerful GPU Hosting";
      sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
   };
  return (
    <>
    <Helmet>
        <title>GPU Dedicated Server France | Powerful GPU Hosting</title>
        <meta name="description" content="Get enterprise-grade GPU dedicated servers in France for AI, big data, and 3D workloads with low latency and dedicated resources." />
        <meta name="keywords" content="GPU Server Hosting, GPU Dedicated Server Hosting, GPU Dedicated Server France" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/gpu-dedicated-server-france`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/gpu-dedicated-server-france`} />
        <meta property="og:title" content="Server Farm & Virtualization GPU Dedicated Servers in France" />
        <meta property="og:description" content="Deploy reliable virtualized, and server farms with a GPU dedicated server in France. Our robust infrastructure offers reliability with top-tier VM processing." />
    </Helmet>
    <section className="banner-bg bg-dark server-banner special-tilt-pb">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-xl-6">
                    <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Home For France's Server
                    </span>
                    <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Bonjour to GPU Dedicated Server France
                    </h1>
                    <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        It began like any other task-unnecessary boots, infinite waiting... until the GPU dedicated server France entered the group chat. This is not only a server-it’s a shift-the right moment where everything gets quicker, smoother, and suddenly... possible from impossible.
                    </p>
                    <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <span className="btn-arrow__text">
                                Get Started
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </button>
                        <MinPlanPrice category="customizedgdsfr" />
                    </div>
                    <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                    <img src="/images/bonjour-to-gpu-dedicated.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                </div>
            </div>
        </div>
    </section>

    <section className="domain-container position-relative z-1 overflow-hidden special-domain-container">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10">
                        <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                            <div className="card-body pt-60 pb-60">
                                <div className="row justify-content-center">
                                  <div className="col-md-11 col-lg-10 col-xl-10">
                                      <div className="text-center">
                                        <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Your Server = Your Fav Coffee Shop</span>
                                          <h4 className="mb-4">
                                              Your Next GPU Dedicated Server Might Be Closer Than Your Favorite Coffee Shop
                                          </h4>
                                          <p className="mb-6">
                                            Why always let a huge distance slow you down? With the help of a GPU dedicated server available in different global places, you can select one that’s practically next door-zero lag, high speed-and yes, closer than your everyday coffee run. Tap in and just feel the difference by yourself.
                                          </p>
                                          <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                              <span className="d-inline-block me-1 flex-shrink-0">
                                                  <i className="las la-comments"></i>
                                              </span>
                                              <span className="btn-arrow__text">
                                                  +91-7737300013
                                                  <span className="btn-arrow__icon">
                                                      <i className="fa-solid fa-arrow-right"></i>
                                                  </span>
                                              </span>
                                          </Link>
                                          <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                              <span className="d-inline-block me-1 flex-shrink-0">
                                                  <i className="las la-comments"></i>
                                              </span>
                                              <span className="btn-arrow__text">
                                                  Talk to an Expert
                                                  <span className="btn-arrow__icon">
                                                      <i className="fa-solid fa-arrow-right"></i>
                                                  </span>
                                              </span>
                                          </Link>
                                      </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>

    <div className="pt-100 pb-100">
        <div className="container">
            <div className="row align-items-center g-4">
                <div className="col-xxl-5 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Two Words: Infinitive Host</small>
                    <h2 className="h3 mb-3">
                        What Made Everyone Switch? Four Words: GPU Dedicated Server France.
                    </h2>
                    <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-lg btn-lg fs-14 fw-semibold rounded transition btn-height">
                        <span className="btn-arrow__text">
                            View Pricing
                            <span className="btn-arrow__icon">
                                <i className="fa-solid fa-arrow-right"></i>
                            </span>
                        </span>
                    </Link>
                </div>
                <div className="col-xxl-7">
                    <div className="row g-4">
                        <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="card hover-shadow rounded-3 border border-secondary transition h-100">
                                <div className="card-body p-xl-6">
                                    <div className="mb-4">
                                        <img src="images/live-like-a-pro.webp" alt="icon" className="img-fluid" />
                                    </div>
                                    <h6 className="mb-4">
                                        Live Like a Pro
                                    </h6>
                                    <p className="mb-0">Our NVIDIA GPU Server France setup guarantees unbeatable performance, all thanks to Tier-4 data centers. Get high uptime powered by ISO-verified security.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="card hover-shadow rounded-3 border border-secondary transition h-100">
                                <div className="card-body p-xl-6">
                                    <div className="mb-4">
                                        <img src="images/the-sweet-spot-server.webp" alt="icon" className="img-fluid" />
                                    </div>
                                    <h6 className="mb-4">
                                        The Sweet Spot Server
                                    </h6>
                                    <p className="mb-0">Experience major performance growth with a GPU Dedicated Server France-mixing high-speed processing and memory into one solid package.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="card hover-shadow rounded-3 border border-secondary transition h-100">
                                <div className="card-body p-xl-6">
                                    <div className="mb-4">
                                        <img src="images/tough-loads-managed.webp" alt="icon" className="img-fluid" />
                                    </div>
                                    <h6 className="mb-4">
                                        Tough Loads, Managed
                                    </h6>
                                    <p className="mb-0">Tackle AI, big data, and gaming with the help of our GPU hosting server France. These tested, advanced servers are engineered for long-term reliability.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="card hover-shadow rounded-3 border border-secondary transition h-100">
                                <div className="card-body p-xl-6">
                                    <div className="mb-4">
                                        <img src="images/no-setup-fees-ever.webp" alt="icon" className="img-fluid" />
                                    </div>
                                    <h6 className="mb-4">
                                        No Setup Fees. Ever.
                                    </h6>
                                    <p className="mb-0">Your well-known NVIDIA GPU Server France always comes ready-zero setup charges, no more unexpected surprises-just exceptional performance.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 

    <section className="price-plan-section pt-100 pb-100">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> From Us, Just For You</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'customizedgdsfr'}/>
    </section>

    <section className="pt-100 pb-100 bg-white">
        <div className="container">
            <div className="bg-white px-8  rounded-3">
                <div className="row align-items-center g-4">
                    <div className="col-lg-5">
                        <img src="images/built-fully-like-a-bugatti.webp" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
                    </div>
                    <div className="col-lg-7">
                        <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="w-2 h-2 rounded-circle bg-primary"></div>
                            <small className="text-primary fw-bold">Speed Just Like Any Super Car!!</small>
                        </div>
                        <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Built Fully Like a Bugatti, Hosted Freely in France</h2>
                        <p className="mb-0 sal-animate mb-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"> Top-notch, precision-powered, and engineered to rule-our GPU dedicated server France offers blazing-fast performance without any luxury price tag. Why crawl like a snail when you can host with the speed of a Bugatti?</p>
                        <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                            <span className="d-inline-block me-1 flex-shrink-0">
                                <i className="las la-comments"></i>
                            </span>
                            <span className="btn-arrow__text">
                                Talk to an Expert
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="pt-100 pb-60">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-8 col-xl-10">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Layers of Performance, Done Right
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Just Like a Freshly Baked Croissant: Layered, Lightweight, and Powerful</h2>
                        <p className="text-dark mb-0 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Just like your fav French cafe, engineered to unbeatable perfection. Our best GPU dedicated server France offers unbeatable performance, unbreakable security, and exceptional management-hot, instant, and always ready.</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Launch Day? Now.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/live-in-hours.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Get your NVIDIA GPU Server France live in only 4 hours-the operating system and panel are added, with no waiting.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">All Cores, All In</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/all-setup.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Run all challenging tasks along with Intel Xeon on our GPU Dedicated Server France, where power meets reliability.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Yours. Only Yours.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/only-for-your-needs.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">With the help of dedicated GPU server hosting France, all the hardware is fully yours. No more sharing. No slowdown.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Security Baked In</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/encrypted-&-secure.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Your chosen NVIDIA GPU server France has a free SSL certificate-protecting every single byte and user interaction.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Speed Like Espresso</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/no-slow-speeds-just-10-Gbps.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Experience blazing-fast speeds along with a GPU dedicated server France-an ideal fit for real-time applications.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Tomorrow’s Tech, Now</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/tomorrow-tech-now.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">We always use the advanced infrastructure in dedicated GPU server hosting France-all set for heavy workloads.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">You Lead the Show</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">07</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/custom-just-like-your.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Customize every single thing that is available on your GPU Dedicated Server France, ranging from software to security.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Big Data? No Issues.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">08</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/big-data-no-issues.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Crush both AI and data-based heavy tasks with dedicated GPU server hosting France, enhanced for performance.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="pt-100 pb-100">
        <div className="container">
            <div className="feature-1-wrapper px-10 py-14 bg-white rounded-3 position-relative z-2">
                <img src="images/feature-shape.png" alt="image" className="img-fluid position-absolute end-0 top-0 z-n1 flip-x" />
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8">
                        <div className="text-center mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <h2 className="mb-3">Benefits of Our France Servers</h2>
                        </div>
                    </div>
                </div>
                <div className="row g-lg-4 justify-content-center">
                    <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Engineered to manage AI, ML, and data science tasks efficiently.</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Supports all advanced computing for real-time outcomes.</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Improves performance in neural network training and inference.</p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-4 sal-animate another-ipad-mt" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Decreased latency in computation-powered environments.</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Improves multitasking with high concurrency management.</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Perfect for 3D graphics rendering and scientific simulations.</p>
                            </li>
                        </ul>
                    </div>
                   
                </div>
            </div>
        </div>
    </section>

    </>
  );
}
